import React from 'react';
import IconBase from './IconBase';

const DashboardIcon = props => {
    return (
        <IconBase {...props}>
            <path d="M4.5,7.5h1c1.1,0,2-0.9,2-2v-1c0-1.1-0.9-2-2-2h-1c-1.1,0-2,0.9-2,2v1C2.5,6.6,3.4,7.5,4.5,7.5z"/>
            <path d="M16.5,4.5v1c0,1.1,0.9,2,2,2h1c1.1,0,2-0.9,2-2v-1c0-1.1-0.9-2-2-2h-1C17.4,2.5,16.5,3.4,16.5,4.5z"/>
            <path d="M9.5,4.5v1c0,1.1,0.9,2,2,2h1c1.1,0,2-0.9,2-2v-1c0-1.1-0.9-2-2-2h-1C10.4,2.5,9.5,3.4,9.5,4.5z"/>
            <path d="M4.5,14.5h1c1.1,0,2-0.9,2-2v-1c0-1.1-0.9-2-2-2h-1c-1.1,0-2,0.9-2,2v1C2.5,13.6,3.4,14.5,4.5,14.5z"/>
            <path d="M16.5,11.5v1c0,1.1,0.9,2,2,2h1c1.1,0,2-0.9,2-2v-1c0-1.1-0.9-2-2-2h-1C17.4,9.5,16.5,10.4,16.5,11.5z"/>
            <path d="M9.5,11.5v1c0,1.1,0.9,2,2,2h1c1.1,0,2-0.9,2-2v-1c0-1.1-0.9-2-2-2h-1C10.4,9.5,9.5,10.4,9.5,11.5z"/>
            <path d="M4.5,21.5h1c1.1,0,2-0.9,2-2v-1c0-1.1-0.9-2-2-2h-1c-1.1,0-2,0.9-2,2v1C2.5,20.6,3.4,21.5,4.5,21.5z"/>
            <path d="M16.5,18.5v1c0,1.1,0.9,2,2,2h1c1.1,0,2-0.9,2-2v-1c0-1.1-0.9-2-2-2h-1C17.4,16.5,16.5,17.4,16.5,18.5z"/>
            <path d="M9.5,18.5v1c0,1.1,0.9,2,2,2h1c1.1,0,2-0.9,2-2v-1c0-1.1-0.9-2-2-2h-1C10.4,16.5,9.5,17.4,9.5,18.5z"/>
        </IconBase>
    )
}

export default DashboardIcon;